// src/App.js or a dedicated checkout page
import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from '../pages/stripe/checkoutForm';

const stripePromise = loadStripe('pk_test_51RsyymF23sMhv03reztevurR6kS5Fy092VQeqcqNlj1OYbzQiCEEEhC1FyDkFdwgl30QPIOWqRAetR4yL5ikkQzk00pmJjfssL'); // Replace with your actual key

const Upgrade = ()=> {
  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm />
    </Elements>
  );
}

export default Upgrade;